import { render } from "./question.vue?vue&type=template&id=30589d04&scoped=true&lang=pug"
import script from "./question.vue?vue&type=script&setup=true&lang=js"
export * from "./question.vue?vue&type=script&setup=true&lang=js"

import "./question.vue?vue&type=style&index=0&id=30589d04&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30589d04"]])

export default __exports__